<template>
  <transition name="scale-up-center">
    <div v-show="show" class="input-gift">
      <VuiButton type="text" long @click.native="hide"><img src="@/assets/svg/icon-back.svg"></VuiButton>
      <div class="gift-list">
        <div class="gift-item" v-for="(v, k) in giftTable" :key="k">
          <img :src="`/img/gift/${v.src}`" :class="{ active: selectedGift.value === k }" @click="selectGift(v)">
          <p class="name">{{ v.name }}</p>
          <p class="cost">
            <template v-if="!v.coinCost && !v.diamondCost">
              <span>{{ giftShowString }}</span>
            </template>
            <template v-if="v.coinCost">
              <span>{{ v.coinCost }}</span>
              <vui-ico class="ibang-bean" :w="14"></vui-ico>
            </template>
            <template v-if="v.diamondCost">
              <span>{{ v.diamondCost }}</span>
              <vui-ico class="ibang-diamond" :w="14"></vui-ico>
            </template>
          </p>
        </div>
      </div>
      <div class="control">
        <p class="remain">
          <section>
            <vui-ico class="ibang-bean" :w="14"></vui-ico>
            <span>{{coinRemain}}</span>
          </section>
          <section>
            <vui-ico class="ibang-diamond" :w="14"></vui-ico>
            <span>{{diamondRemain}}</span>
          </section>
        </p>
        <VuiButton type="warning" class="btn-send" :disabled="!allowed" @click.native="send()">发送</VuiButton>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedGift: {
      type: Object,
      default () {
        return {}
      },
    },
    imIsConnected: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      timer: -1,
      $runed: false,
      giftShowString: '',
      coinRemain: 0,
      diamondRemain: 0,
    }
  },
  computed: {
    ...mapState('chat', ['giftTable']),
    allowed () {
      // 当计时结束同时已经选择礼物以后可发送礼物
      return this.selectedGift.value
        && this.diamondRemain >= this.selectedGift.diamondCost
        && this.coinRemain >= this.selectedGift.coinCost
        && (this.selectedGift.diamondCost || this.selectedGift.coinCost || this.timer === -1)
    },
  },
  methods: {
    hide () {
      this.$emit('hide')
    },
    selectGift (gift) {
      this.$emit('select', gift)
    },
    send () {
      if (!this.selectedGift.coinCost && !this.selectedGift.diamondCost) {
        this.startTimer()
      }
      this.$emit('send')
    },
    startTimer () { // 免费礼物计时
      this.timer = this.timer === -1 ? Date.now() : this.timer
      setTimeout(() => {
        const delay = 60 * 1000
        const second = ~~((this.timer + delay - Date.now()) / 1000)
        if (second <= 0) {
          this.giftShowString = '1'
          this.timer = -1
        } else {
          const m = ~~(second / 60)
          const s = second % 60
          this.giftShowString = `${m < 10 ? `0${m}` : m}:${s < 10 ? `0${s}` : s}`
          this.startTimer()
        }
      }, 1000)
    },
  },
  watch: {
    imIsConnected (val) {
      if (val && !this.$runed) {
        this.startTimer()
        this.$runed = true
      }
    },
    show (val) {
      // 每次打开的时候重新获取法豆和法钻数量
      if (val) {
        this.$store.dispatch('chat/getMyPower').then(data => {
          this.coinRemain = data.coinValue || 0
          this.diamondRemain = data.diamondValue || 0
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.input-gift {
  @include pos(absolute, auto, 0, 0, 0, 3);
  padding: 0 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: rgba(0, 0, 0, 0.8);

  .gift-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .gift-item {
    flex-shrink: 0;
    flex-grow: 0;
    text-align: center;
    width: 25%;
    img {
      @include wh(64px, 64px);
      border: 1px solid transparent;
      border-radius: 4px;
      cursor: pointer;

      &.active {
        background-color: rgba(0, 0, 0, 0.2);
        border-color: rgba(255, 255, 255, 0.3);
      }
    }

    .name {
      @include font(12px, 14px, #fff);
      text-align: center;
    }
    .cost {
      @include font(12px, 14px, #fff);
      text-align: center;
      margin-top: 5px;
      span {
        margin-right: 3px;
      }
    }
  }

  .control {
    margin-top: 12px;
    padding: 6px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .remain {
      display: flex;
      @include font(12px, 14px, #fff);
      section {
        margin-right: 10px;
        span {
          margin-left: 2px;
        }
      }
    }
    .btn-send {
      @include font(12px, 16px);
      padding: 2px 16px;
      border-radius: 16px;
    }
  }
}
</style>
